import { AppBar, AppBarProps, Box, Toolbar } from '@mui/material';
import { ReactElement, ReactNode } from 'react';
import { SizingMultiplier } from '../../sizing-multiplier.constant';

type NavigationBarProps = {
  isElevationDisabled?: boolean;
  position?: AppBarProps['position'];
  left?: ReactElement;
  center?: ReactNode;
  right?: ReactElement;
  color?: 'default' | 'transparent';
  hideRightSection?: boolean;
  'data-testid'?: string;
};

export const NavigationBar = (props: NavigationBarProps) => {
  const {
    isElevationDisabled = false,
    position = 'static',
    left,
    center,
    right,
    color,
    hideRightSection,
    'data-testid': dataTestId,
  } = props;

  return (
    <AppBar
      position={position}
      elevation={isElevationDisabled ? 0 : undefined}
      sx={{ pt: 'var(--ion-safe-area-top, 0)' }}
      color={color}
      data-testid={dataTestId}>
      <Toolbar sx={{ px: SizingMultiplier.xs, justifyContent: 'space-between' }}>
        <Box width={56}>{left}</Box>
        {center}
        {!hideRightSection && (
          <Box width={56} display="flex" justifyContent="flex-end">
            {right}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};
